var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.233 15.328a4.773 4.773 0 0 0 -4.7-4.078h-1.064a4.773 4.773 0 0 0 -4.7 4.078l-.51 3.566a.75.75 0 0 0 .213.636c.2.2 1.427 1.22 5.53 1.22s5.327-1.016 5.53-1.22a.75.75 0 0 0 .213-.636z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.56 11.8a5.7 5.7 0 0 0 -1.78 3.39l-.37 2.56c-2.97-.02-3.87-1.1-4.02-1.32a.739.739 0 0 1 -.13-.56l.22-1.24a4.093 4.093 0 0 1 6.08-2.83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.74 15.87a.739.739 0 0 1 -.13.56c-.15.22-1.05 1.3-4.02 1.32l-.37-2.56a5.7 5.7 0 0 0 -1.78-3.39 4.093 4.093 0 0 1 6.08 2.83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.73 9.6a2.714 2.714 0 0 1 -2.23 1.15 2.75 2.75 0 1 1 1.65-4.95 4.812 4.812 0 0 0 -.15 1.2 5.01 5.01 0 0 0 .73 2.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.25 8a2.748 2.748 0 0 1 -2.75 2.75 2.714 2.714 0 0 1 -2.23-1.15 5.01 5.01 0 0 0 .73-2.6 4.812 4.812 0 0 0 -.15-1.2 2.75 2.75 0 0 1 4.4 2.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 3.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.33e8d9473f0b84401868f927a6a6a126.svg";
export { ForwardRef as ReactComponent };